<asax-sky-view-aladin-popover-footprint [footprint]="footprint | async">
</asax-sky-view-aladin-popover-footprint>

<asax-sky-view-aladin-popover-search-radius [searchRadius]="searchRadius | async">
</asax-sky-view-aladin-popover-search-radius>

<asax-sky-view-aladin-popover-sky-object [skyObject]="skyObject | async">
</asax-sky-view-aladin-popover-sky-object>

<asax-sky-view-aladin-popover-contextmenu [raDec]="raDec | async">
</asax-sky-view-aladin-popover-contextmenu>
